import type { FieldPath } from "react-hook-form";
import type { FixedProductInput } from "@vy/types";

export const FIXED_CHARGES_EDIT_COLUMNS_KEYS = Object.freeze({
    TYPE: 'variants.0.pricing.pricingModel',
    NAME: 'variants.0.name',
    DESCRIPTION: 'variants.0.description',
    OTHER: 'other',
    QUANTITY: 'quantity',
} satisfies Record<string, FieldPath<FixedProductInput> | 'other' | 'quantity'>);